import type {SlideshowItem} from '@PosterWhiteboard/items/slideshow-item/slideshow-item.class';
import type {VideoSlideItem} from '@PosterWhiteboard/items/slideshow-item/slide-items/video-slide-item.class';
import {getSingleActiveItemObjectOnPage} from '@Components/poster-editor/poster-editor-reducer';
import {useAppSelector} from '@/hooks';

interface UseGetSlideShowItemWithSelectedVideoSlideProps {
  activeItem: SlideshowItem;
  activeSlide: VideoSlideItem;
}

export function useGetSlideShowItemWithSelectedVideoSlide(): UseGetSlideShowItemWithSelectedVideoSlideProps {
  const singleActiveItem = useAppSelector((state) => {
    return getSingleActiveItemObjectOnPage(state);
  });
  const activeItem = singleActiveItem ? window.posterEditor?.whiteboard?.getItemForId(singleActiveItem.uid) : null;

  if (!activeItem) {
    throw new Error(`Active item not found`);
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected the active item to be a slideshow item, instead got ${activeItem?.gitype}`);
  }

  const activeSlide = activeItem.getSelectedSlide();

  if (!activeSlide.isVideoSlide()) {
    throw new Error(`Expected the active slide to be a video slide, instead got ${activeItem?.getSelectedSlide().gitype}`);
  }

  return {
    activeItem,
    activeSlide,
  };
}
